import { useAxios } from '../Plugins/axios';
import { useMitt } from '../Plugins/mitt';
import { useSpinner } from '../Plugins/spinner';
import { useRoute } from '../Plugins/ziggy';
export default class FertilizationService {
    axios;
    route;
    spinner;
    emitter;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
        this.spinner = useSpinner();
        this.emitter = useMitt();
    }
    getAll(orchard_id, plot_id) {
        return this.axios
            .get(this.route('api.fertilizations.index', {
            plot_id: plot_id ?? '',
            orchard_id,
        }))
            .then((response) => response.data.data);
    }
    save(data) {
        let url = data.has('id')
            ? this.route('api.fertilizations.update', [data.get('id')])
            : this.route('api.fertilizations.store');
        this.spinner.show();
        return this.axios
            .post(url, data)
            .then((response) => {
            const data = response.data.data;
            this.emitter.emit('fertilization-saved', data);
            return data;
        })
            .finally(() => this.spinner.hide());
    }
    update(id, data) {
        data['_method'] = 'PUT';
        return this.axios
            .post(this.route('api.fertilizations.update', { id }), data)
            .then((response) => response.data.data);
    }
    destroy(ids) {
        return this.axios
            .post(this.route('api.fertilizations.destroyMultiple'), {
            _method: 'DELETE',
            ids,
        })
            .then((response) => response.data.data);
    }
}
